/**
 * Tipos relacionados à Lista de Verificação Administrativa
 */

export interface ItemVerificacao {
  codigo: string; // Ex: "C.4.1"
  descricao: string;
  possui: boolean | null; // null = não informado, true = possui, false = não possui
  observacao?: string;
}

export interface ListaVerificacaoAdministrativa {
  itens: ItemVerificacao[];
}

// Itens padrão da lista de verificação administrativa.
// Nota: o antigo item "C.4.1 - Apreciação de Riscos conforme ISO 12100" foi
// removido a pedido do usuário; os demais foram renumerados para C.4.1–C.4.9.
export const ITENS_VERIFICACAO_PADRAO: ItemVerificacao[] = [
  {
    codigo: 'C.4.1',
    descricao: 'Estudo de classificação de áreas IEC 60079',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.2',
    descricao: 'Manual de instruções de operação',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.3',
    descricao: 'Plano de manutenção preventiva ou corretiva',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.4',
    descricao: 'Plano de bloqueio de energias',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.5',
    descricao: 'Registro de treinamento para colaboradores',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.6',
    descricao: 'Diagrama elétrico',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.7',
    descricao: 'Diagrama hidráulico',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.8',
    descricao: 'Diagrama pneumático',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.9',
    descricao: 'LTCAT - Laudo Técnico das Condições Ambientais do Trabalho',
    possui: null,
    observacao: ''
  },
  {
    codigo: 'C.4.10',
    descricao: 'AET - Análise Ergonômica do Trabalho',
    possui: null,
    observacao: ''
  }
];

